import * as React from "react";
import Header from "./Header";
import FiledForm from "../filed/FiledForm";

export default function LayoutHome() {
  return (
    <>
      <Header />
      <FiledForm />
    </>
  );
}
